import {useAppSelector} from '@src/Store/hooks';

const usePageSliceParams = () => {
  return useAppSelector(state => state.page.params);
};

export default usePageSliceParams;
